import { render, staticRenderFns } from "./User.tab.vue?vue&type=template&id=ee4ab090&"
import script from "./User.tab.vue?vue&type=script&lang=ts&"
export * from "./User.tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports